import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 32px 24px;
  margin-top: 8px;
`;

export const OrderNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  margin-bottom: 48px;
  width: 466px;
`;
export const OrderInputWrapper = styled.div`
  position: relative;
`;
export const OrderItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ItemText = styled.span<{ bold?: boolean; isTitle?: boolean }>`
  font-weight: ${({ bold, isTitle }) => (bold || isTitle ? '600' : '400')};
  font-size: ${({ isTitle }) => (isTitle ? '24' : '16')}px;
  line-height: ${({ isTitle }) => (isTitle ? '32' : '24')}px;
  color: ${({ theme, isTitle }) =>
    isTitle ? theme.colors.grayDark3 : theme.colors.grayDark4};
`;

export const AlertWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1.5rem;
`;

export const ItemAlertWrapper = styled.div`
  grid-column: span 8;
  @media (max-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    grid-column: span 10;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-column: span 12;
  }
`;

export const OrderDetailsValuesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  flex-wrap: wrap;
  @media (max-width: ${({ theme }) => theme.breakpoints.laptopL}) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export enum AlertOrderType {
  danger = 0,
  warning = 1,
  success = 2
}

const alertStyles = {
  [AlertOrderType.danger]: css`
    border: solid 0.125rem #dc3545;
    background-color: #f8d7da;
    color: ${({ theme }) => theme.colors.grayDark4};
  `,
  [AlertOrderType.warning]: css`
    border: solid 0.125rem #ffc107;
    background-color: #fff3cd;
    color: ${({ theme }) => theme.colors.grayDark4};
  `,
  [AlertOrderType.success]: css`
    border: solid 0.125rem #477237;
    background-color: #edf6e5;
    color: ${({ theme }) => theme.colors.grayDark4};
  `
};

export const AlertOrderContainer = styled.div<{ alertType: AlertOrderType }>`
  padding: 0.75rem 1rem;
  width: fit-content;
  display: block;
  gap: 0.75rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  ${({ alertType }) => alertStyles[alertType]}
`;

export const AlertOrderHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const AlertOrderIcon = styled.div`
  margin-right: 1rem;
  font-size: 1.5rem;
`;

export const AlertOrderTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AlertOrderMessage = styled.div`
  margin-bottom: 0.5rem;
`;
